import React, { useEffect, useRef } from "react";
import { countryCodes } from "../CountryCodes";
import { useState, useMemo } from 'react';
import useStyles from "src/app/maintenance/assets/styles";
import { Grid, IconButton, InputAdornment, InputBase } from "@material-ui/core";
import { DownArrowIcon, UpArrow } from "src/components/Icons";
import { CountryCodeDropdownProps } from "src/app/models";

export const CountryCodeComponent = ({ value, onChange, errors, type }: CountryCodeDropdownProps) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const classes = useStyles();
    const optionRef = useRef(null);

    const getCountryKey = (country: { code: string; dial_code: string; name: string }) => {
        return `${country.code}_${country.dial_code}_${country.name.replace(/\s+/g, '_')}`;
    };

    const getFilteredCountries = () => {
        if (!searchTerm) return countryCodes;
        const term = searchTerm.toLowerCase();
        return countryCodes.filter(country =>
            country.name.toLowerCase().includes(term) ||
            country.dial_code.toLowerCase().includes(term)
        );
    };

    const filteredCountries = useMemo(getFilteredCountries, [searchTerm]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
        setIsOpen(true);
    };

    const handleSelect = (country: { dial_code: string }) => {
        onChange({ target: { value: country.dial_code } });
        setIsOpen(false);
        setSearchTerm('');
    };

    const getSelectedCountryDisplay = () => {
        if (!value) return '';
        const foundCountries = countryCodes.filter(c => c.dial_code === value);
        if (foundCountries.length === 0) return '';
        return `${value} (${foundCountries[0].name})`;
    };

    const getDisplayValue = () => {
        if (searchTerm) return searchTerm;
        return getSelectedCountryDisplay();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (optionRef.current && !optionRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <Grid ref={optionRef} item xs={12} md={12} style={{ position: 'relative', margin: '0px' }}>
            <Grid item className={classes.inputContainer}>
                <InputBase
                    type="text"
                    placeholder={type === 'alert-add' ? 'Select Your Country Code' : ''}
                    value={getDisplayValue()}
                    onChange={handleInputChange}
                    onFocus={() => setIsOpen(true)}
                    className={classes.formInput}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => setIsOpen(!isOpen)}
                                edge="end"
                            >
                                {isOpen ? <UpArrow /> : <DownArrowIcon />}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </Grid>

            {isOpen && (
                <Grid item className={classes.dropdown} style={{width:"300px"}}>
                    {type === 'alert-add' && !searchTerm && (
                        <div className={classes.countryCodeOption}>
                            Please Select Your Country Code
                        </div>
                    )}

                    {filteredCountries.map((country) => (
                        <div
                            key={getCountryKey(country)}
                            onClick={() => handleSelect(country)}
                            className={classes.option}
                        >
                            {country.dial_code} ({country.name})
                        </div>
                    ))}
                </Grid>
            )}

            {errors.countryCode && (
                <span className="form-error">
                    {errors.countryCode}
                </span>
            )}
        </Grid>
    );
};